
import React, { useContext, useState, useRef, useEffect, useCallback, forwardRef, useImperativeHandle, useReducer  } from 'react';
import axios from 'axios';
import { DataGridPremium } from '@mui/x-data-grid-premium';
import { Notifications, Help, ArrowDropDown, Upload, UploadFileOutlined, CloseIcon, CloseRounded, } from '@mui/icons-material';
import AddIcon from '@mui/icons-material/Add';
import SearchIcon from '@mui/icons-material/Search';
import {
  AppBar,
  Toolbar,
  IconButton,
  Typography,
  Menu,
  MenuItem,
  Avatar,
  Button,
  Badge,
  Box,
  Select,
  Divider,
  Drawer,
  TextField,
  InputLabel,
  FormControl,
  FormControlLabel,
  Checkbox,
  InputAdornment,
  Paper, 
  Stack,
  Tabs,
} from '@mui/material';

import ClearIcon from '@mui/icons-material/Clear';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import Search from '@mui/icons-material/Search';
import Tab from '@mui/material/Tab';
import { formatDistanceToNow, parseISO } from "date-fns";
import {
    ValidationUtility,
    CaseDocumentsModel, caseDocumentsModel,
    TextFieldWithIconButton,    
    CustomAutoComplete,
    SearchTextFieldCustom,
    DocumentUtility,
    UtilityLibrary,
    caseDataService,
    batchDataService,
    BusinessUtility,
    ApiManager,
    sessionService,
    SessionManager,
    EnumUtility,
    LoggerUtility,
    ConfirmationDialog,
    NotificationDialog,
    RoundedSquareRefreshButton,
    WhiteRefreshIcon,
    FetchControls,
    DeterminePermissions,
    PageLoader
} from '../ComponentsLibrary';

import AlertNotification from '../AlertNotification';

const MyYTrac = forwardRef((props, ref) => {

    const errorFormName = "Queue - Workflow";

    // Initial state for the form fields
    const initialFormData = {
        hasValidCaseData: true,
        hasValidDateData: true,
        startDateTxt: "",
        endDateTxt: "",
        caseSearchTxt: "",
        workflowSelect: "",
        queueSelect: "",
    };

    function formReducer(state, action) {
        switch (action.type) {
            case 'UPDATE_FIELDS':
                return {
                    ...state,
                    ...action.payload
                };
            case 'RESET_FORM':
                return initialFormData;
            default:
                return state;
        }
    }

    const [searchFormData, dispatch] = useReducer(formReducer, initialFormData);

    const updateFormFieldValues = (updateValues) => {
        dispatch({
            type: 'UPDATE_FIELDS',
            payload: updateValues
        });
    };

    // Validation patterns
    const siteSettingDetail = JSON.parse(SessionManager.GetValueFromSession(SessionManager.SiteSettingsDetailsKey));
    const caseNumberRegex = siteSettingDetail.CaseNumberRegex || { caseRegexValue: "", caseRegexMessage: "" };

    const [activeTab, setActiveTab] = useState(0);
    

    const [notificationDialogOpen, setNotificationDialogOpen] = useState(false);
    const [notificationDialogContent, setNotificationDialogContent] = useState([]);
    const [timerNotificationDialogClose, setTimerNotificationDialogClose] = useState(5000);
    const [timerAutoCloseNotificationDialog, setTimerAutoCloseNotificationDialog] = useState(false);

    const [resultsMyYTrac, setResultsMyYTrac] = useState([]);
    const [systemInfoResults, setSystemInfoResults] = useState([]);
    const [isSystemInfoLoading, setIsSystemInfoLoading] = useState(false);
    
    //const [paginationModel, setPaginationModel] = useState({ pageSize: 15, page: 0 });
    const [gridFilterModel, setGridFilterModel] = useState({ items: [] });
    const [showSupportButton, setShowSupportButton] = useState(false); // Set to false to hide

    const defaultPermissionsForFields = {

        btnMyYTracMyProfile: { read: false, write: false, hide: false },
        btnMyYTracStats: { read: false, write: false, hide: false },
        btnMyYTracAwards: { read: false, write: false, hide: false },
        btnMyYTracSystemInfo: { read: false, write: false, hide: false },
        
    }
    const [formFieldAccess, setFormFieldAccess] = useState(defaultPermissionsForFields);

      useEffect(() => {
          // 🔍 UPDATED: Read permissions from session (set by SiteSelector)
          const userPermissions = SessionManager.GetDataFromSession("UserPermissions");
          
          if (userPermissions) {
              setFormFieldAccess(userPermissions);
          } else {
              console.log('🔍 AppBar no permissions in session, using defaults');
              setFormFieldAccess(defaultPermissionsForFields);
          }
      }, []);
    
      // 🔍 ADD: Listen for session changes
      useEffect(() => {
          const handleStorageChange = () => {
              const userPermissions = SessionManager.GetDataFromSession("UserPermissions");
              if (userPermissions) {
                  setFormFieldAccess(userPermissions);
              }
          };
    
          window.addEventListener('storage', handleStorageChange);
          return () => window.removeEventListener('storage', handleStorageChange);
      }, []);

    

    // Grid Columns: System Information
    // const systemInfoGridColumns = [
    //     { field: 'item', headerName: 'Item', flex: 1 },
    //     { field: 'value', headerName: 'Value', flex: 2 },
    //     //{ field: 'description', headerName: 'Description', flex: 2 },
    // ];
    const systemInfoGridColumns = [
    { 
        field: 'item', 
        headerName: 'Item', 
        flex: 1,
        renderCell: (params) => (
            <div style={{ 
                whiteSpace: 'pre-wrap', 
                wordWrap: 'break-word',
                lineHeight: '1.4',
                padding: '8px 0'
            }}>
                {params.value}
            </div>
        )
    },
    { 
        field: 'value', 
        headerName: 'Value', 
        flex: 2,
        renderCell: (params) => (
            <div style={{ 
                whiteSpace: 'pre-wrap', 
                wordWrap: 'break-word',
                lineHeight: '1.4',
                padding: '8px 0'
            }}>
                {params.value}
            </div>
        )
    },
    
    // {
    //     field: 'actions',
    //     headerName: 'Actions',
    //     width: 120,
    //     sortable: false,
    //     filterable: false,
    //     renderCell: (params) => (
    //         <Button
    //             variant="outlined"
    //             size="small"
    //             onClick={() => handleAction(params.row)}
    //         >
    //             Action
    //         </Button>
    //     ),
    // },
];

    
      const [alertProps, setAlertProps] = useState({
        type: '',
        message: '',
        open: false,
      });
    
      const showAlert = (type, message) => {
        setAlertProps({ type, message, open: true });
      };
      
    const handleAlertClose = () => {
        setAlertProps((prevState) => ({ ...prevState, open: false }));
    };

    const handleCopyToClipboard = () => {
        // Create formatted text content
        const textContent = systemInfoResults.map(row => 
            `${row.item}\t${row.value}` // Tab-separated for easy pasting into Excel
        ).join('\n');

        const csvFormat = ['Item,Value', ...systemInfoResults.map(row => {
            const escapeCSV = (text) => text.includes(',') || text.includes('"') || text.includes('\n') 
                ? `"${text.replace(/"/g, '""')}"` : text;
            return `${escapeCSV(row.item)},${escapeCSV(row.value)}`;
        })].join('\n');
        
        const htmlTable = `
            <table border="1" cellpadding="4" cellspacing="0">
                <thead><tr><th>Item</th><th>Value</th></tr></thead>
                <tbody>
                    ${systemInfoResults.map(row => `<tr><td>${row.item}</td><td>${row.value}</td></tr>`).join('')}
                </tbody>
            </table>
        `;
        
        const jsonData = systemInfoResults.map(row => ({
        item: row.item,
        value: row.value,
        id: row.id
    }));
    
    const jsonContent = JSON.stringify(jsonData, null, 2); // Pretty formatted JSON

    const emailContent = `
${systemInfoResults.map(row => `${row.item}:
${row.value}

`).join('')}

`;

     // Create email-friendly formatted text
//     const emailContent = `
// System Information Report
// Generated: ${new Date().toLocaleString()}
// ${'='.repeat(50)}

// ${systemInfoResults.map(row => `${row.item}:
// ${row.value}

// `).join('')}

// ${'='.repeat(50)}
// End of Report
// `;
        // Add header
        //const fullContent = `Item\tValue\n${emailContent}`;
        const fullContent = `${emailContent}`;
        
        // Copy to clipboard
        navigator.clipboard.writeText(fullContent).then(() => {
            showAlert('success', 'Data copied to clipboard. You can paste it into any file or application.');
        }).catch(err => {
            console.error('Failed to copy: ', err);
            showAlert('error', 'Failed to copy data to clipboard');
        });

        console.log('Copy clicked');
        // Copy to clipboard logic
    };

    const handleSupportSystemInfo = () => {
        console.log('Support clicked');
        // Email system info data
        const dataToExport = systemInfoResults.map(row => ({
            Item: row.item,
            Value: row.value
        }));
        console.log('Supporting data:', dataToExport);
    };

//   const handleAction = (row) => {
//     console.log('Action clicked for row:', row);
//     // Your action logic here
// };

    //=======================================================================
    //  - Begin
    //=======================================================================

    const simulateAsyncDelay = async () => {
        await new Promise((resolve) => setTimeout(resolve, 0));
    }

    // Function to get the ordered list of visible tabs
    const getVisibleTabs = () => {
        const tabs = [];
        if (!(formFieldAccess.btnMyYTracMyProfile?.hide ?? false)) tabs.push('profile');
        if (!(formFieldAccess.btnMyYTracStats?.hide ?? false)) tabs.push('stats');
        if (!(formFieldAccess.btnMyYTracAwards?.hide ?? false)) tabs.push('awards');
        if (!(formFieldAccess.btnMyYTracSystemInfo?.hide ?? false)) tabs.push('systeminfo');
        return tabs;
    };

    // Function to get the current active tab type
    const getCurrentTabType = () => {
        const visibleTabs = getVisibleTabs();
        return visibleTabs[activeTab] || 'profile';
        
    };

    // Add useEffect to set default tab after permissions are loaded
    useEffect(() => {
        const visibleTabs = getVisibleTabs();
        const systemInfoIndex = visibleTabs.findIndex(tab => tab === 'systeminfo');
        if (systemInfoIndex !== -1) {
            setActiveTab(systemInfoIndex);
        }
    }, [formFieldAccess]); // Run when permissions change

    const handleTabChange = async (event, newValue) => {
        try {
            setActiveTab(newValue);
        }
        catch (error) {
            await LoggerUtility.ManageErrorLogging(error, errorFormName, "handleTabChange");
        }
        
    };

    const handleGridFilterChange = async (newFilterModel) => {
        try {
            setGridFilterModel(newFilterModel);
        }
        catch (error) {
            await LoggerUtility.ManageErrorLogging(error, errorFormName, "handleGridFilterChange");
        }
    };

    const handleGridClearFilters = async () => {
        try {
            setGridFilterModel({ items: [] });
        }
        catch (error) {
            await LoggerUtility.ManageErrorLogging(error, errorFormName, "handleGridClearFilters");
        }
    };

    const handleNotificationDialog = (dialogContent, timerAutoClose = false, timeToClose = 5000) => {
        try {
            setNotificationDialogContent(dialogContent);
            setTimerNotificationDialogClose(timeToClose);
            setTimerAutoCloseNotificationDialog(timerAutoClose);
            handleOpenNotificationDialog();
        }
        catch (error) {
            throw LoggerUtility.ProcessErrorData(error, "handleNotificationDialog", {});
        }
    };

    const handleOpenNotificationDialog = () => {
        try {
            setNotificationDialogOpen(true);
        }
        catch (error) {
            throw LoggerUtility.ProcessErrorData(error, "handleOpenNotificationDialog", {});
        }
    };

    const handleCloseNotificationDialog = useCallback(async () => {
        try {
            setNotificationDialogOpen(false);
        }
        catch (error) {
            await LoggerUtility.ManageErrorLogging(error, errorFormName, "handleCloseNotificationDialog");
        }
    }, []);

    

    // const handleRowDoubleClick = (params, event) => {
    //     showAlert('success', 'Double-click initiated!');
    //   };
    const getSessionHost = () => {
            return window.location.hostname; // Returns just the hostname (e.g., "localhost", "example.com")
        };

    const getFullSessionHost = () => {
            return window.location.host; // Returns hostname:port (e.g., "localhost:3000")
        };

    const getSessionOrigin = () => {
            return window.location.origin; // Returns full origin (e.g., "http://localhost:3000")
        };
        
    const getDetailedBrowserInfo = () => {
        // const userAgent = navigator.userAgent;
        // const browsers = [
        //     { name: 'Chrome', regex: /Chrome\/([0-9.]+)/ },
        //     { name: 'Firefox', regex: /Firefox\/([0-9.]+)/ },
        //     { name: 'Safari', regex: /Version\/([0-9.]+).*Safari/ },
        //     { name: 'Edge', regex: /Edg\/([0-9.]+)/ },
        //     { name: 'Opera', regex: /OPR\/([0-9.]+)/ },
        //     { name: 'IE', regex: /(?:MSIE |rv:)([0-9.]+)/ }
        // ];

        // for (const browser of browsers) {
        //     const match = userAgent.match(browser.regex);
        //     if (match) {
        //         //const result = [browser.name, match[1], match[1], match[1].split('.')[0]];
        //         const result = [browser.name, match[1]];
        //         result.name = browser.name + ' ' + match[1];
        //         //result.version = match[1];
        //         // result.fullVersion = match[1];
        //         // result.majorVersion = match[1].split('.')[0];
        //         return result;
        //     }
        // }

        // return "Unknown";
        const userAgent = navigator.userAgent;
        let browserName = 'Unknown Browser';  
        if (userAgent.includes('Chrome') && !userAgent.includes('Edg')) {
            browserName = { name: 'Chrome', regex: /Chrome\/([0-9.]+)/ };
        } else if (userAgent.includes('Firefox')) {
            browserName = { name: 'Firefox', regex: /Firefox\/([0-9.]+)/ };
        } else if (userAgent.includes('Safari') && !userAgent.includes('Chrome')) {
            browserName = { name: 'Safari', regex: /Version\/([0-9.]+).*Safari/ };
        } else if (userAgent.includes('Edg')) {
            browserName = { name: 'Edge', regex: /Edg\/([0-9.]+)/ }
        } else if (userAgent.includes('OPR')) {
            browserName = { name: 'Opera', regex: /OPR\/([0-9.]+)/ };
        } 

        const match = userAgent.match(browserName.regex);
            // if (match) {
            //     //const result = [browserName.name, match[1], match[1], match[1].split('.')[0]];
            //     const result = [browserName.name, match[1]];
            //     result.name = browserName.name;
            //     result.version = match[1];
            //     //result.fullVersion = match[1];
            //     //result.majorVersion = match[1].split('.')[0];
            //     return result;
            // }
            if (match) {
            const fullVersion = match[1];
            const versionParts = fullVersion.split('.');
            
            const result = {
           
                // name: browserName.name,
                // version: fullVersion//,
                // fullVersion: fullVersion,
                // majorVersion: versionParts[0],
                // minorVersion: versionParts[1] || '0',
                // buildNumber: versionParts[2] || '0',
                // revision: versionParts[3] || '0',
                // displayName: `${browserName.name} ${fullVersion}`,
                // shortName: `${browserName.name} ${versionParts[0]}.${versionParts[1] || '0'}`
            };
            
            // Add legacy array format for backward compatibility
            // result[0] = browserName.name;
            // result[1] = fullVersion;
            
            return browserName.name + ' ' + fullVersion;
        }
        return browserName;
    }

    

const getModernBrowserVersionInfo = async () => {
    // Check if the new User Agent Client Hints API is available

    //     if (typeof navigator.userAgentData === 'undefined' || 
    //     typeof navigator.userAgentData.getHighEntropyValues !== 'function') {
    //         return getDetailedBrowserInfo();
    //     }
    //     try {

    //         // Test if the method works with a simple call first
    //         await navigator.userAgentData.getHighEntropyValues([]);
    //         const uaData = await navigator.userAgentData.getHighEntropyValues(['uaFullVersion']);

            
    //         // Get the primary browser from the brand list
    //         const primaryBrand = navigator.userAgentData.brands.find(brand => 
    //             !brand.brand.includes('Not') && 
    //             !brand.brand.includes('Chromium') &&
    //             brand.brand !== 'Google Chrome'
    //         ) || navigator.userAgentData.brands[0];
            
    //         if (primaryBrand && uaData.uaFullVersion) {
    //         return primaryBrand.brand + ' ' + uaData.uaFullVersion;
    //     }
        
    //     } catch (error) {
    //         return getDetailedBrowserInfo();
    //         console.warn('Error getting high entropy values:', error);
    //     }
    

    // // Fallback to traditional method
    // return getDetailedBrowserInfo();
     let browserName = 'Unknown Browser';
    let version = 'Unknown Version';
    
    // Level 1: Try modern API
    if (navigator.userAgentData) {
        try {
            // Get basic brand info (this usually works even if high entropy fails)
            const primaryBrand = navigator.userAgentData.brands.find(brand => 
                !brand.brand.includes('Not') && !brand.brand.includes('Chromium')
            ) || navigator.userAgentData.brands[0];
            
            if (primaryBrand) {
                browserName = primaryBrand.brand;
                version = primaryBrand.version;
                
                // Try to enhance with high entropy data
                // try {
                //     const uaData = await navigator.userAgentData.getHighEntropyValues(['uaFullVersion']);
                //     if (uaData.uaFullVersion) {
                //         version = uaData.uaFullVersion;
                //     }
                // } catch (highEntropyError) {
                //     // Keep the basic version from brands
                //     console.warn('High entropy failed, using basic version:', highEntropyError);
                // }
            }
            
        } catch (basicError) {
            console.warn('Basic userAgentData failed:', basicError);
        }
    }
    
    // Level 2: If modern API failed, parse user agent
    if (browserName === 'Unknown Browser') {
        const fallbackInfo = getDetailedBrowserInfo();
        return fallbackInfo;
    }
    
    return browserName + ' ' + version;
};

const getLocalNetworkInfo = async () => {
    return new Promise((resolve) => {
        const pc = new RTCPeerConnection({
            iceServers: []
        });

        pc.createDataChannel('');

        pc.onicecandidate = (ice) => {
            if (ice && ice.candidate && ice.candidate.candidate) {
                const candidate = ice.candidate.candidate;
                const ipMatch = candidate.match(/([0-9]{1,3}(\.[0-9]{1,3}){3})/);
                
                if (ipMatch) {
                    const localIP = ipMatch[1];
                    pc.close();
                    resolve({
                        localIP: localIP,
                        networkInterface: candidate,
                        note: 'This is the local IP, not computer name'
                    });
                    return;
                }
            }
        };

        pc.createOffer()
            .then(sdp => pc.setLocalDescription(sdp))
            .catch(() => resolve({ error: 'Could not detect local IP' }));

        // Timeout after 3 seconds
        setTimeout(() => {
            pc.close();
            resolve({ error: 'Timeout detecting network info' });
        }, 3000);
    });
};

    const handleSystemInformationBtnClick = async () => {
    setIsSystemInfoLoading(true);
    try {
        const loginUserInfo = sessionService.getUser();
        const legacyUserInfo = sessionService.getLegacyUserID();
        const params = {
            UserLoginID: legacyUserInfo,
            UserInfoID: loginUserInfo?.userInfoID,
            YTracSiteID: loginUserInfo?.siteID,
        };


        
        const systemInformationData = await ApiManager.GetSystemInformationFromAPI(params);

        // Original gridData structure (keeping for reference)
        const originalGridData = Object.entries(systemInformationData).flatMap(([key, value], entryIndex) => {
            const stringValue = typeof value === 'object' ? JSON.stringify(value) : String(value);
            const arrayValue = stringValue.split(',').map(item => item.trim()).filter(item => item.length > 0);
            
            // Create a row for each value in the array
            return arrayValue.map((singleValue, arrayIndex) => {
                // Split the value by double quote followed by colon (":)
                const quoteColonSplit = singleValue.split('":').map(part => part.trim()).filter(part => part.length > 0);
                
                const twoDimensionalValue = quoteColonSplit.length > 1 ? quoteColonSplit : [singleValue];
                
                return {
                    id: `${entryIndex}-${arrayIndex}`, // Unique ID combining entry index and array index
                    item: arrayValue.length > 1 ? `${key.replace(/([A-Z])/g, ' $1').trim()} (${arrayIndex + 1})` : key.replace(/([A-Z])/g, ' $1').trim(),
                    value: singleValue,
                    valueParts: twoDimensionalValue, // 2D array split by quote+colon (":")
                    
                    valueArray: arrayValue, // Original comma-split array
                    originalKey: key,
                    arrayIndex: arrayIndex,
                    totalItems: arrayValue.length
                };
            });
        });

        // New gridData structure using valueParts with item = valueParts[0] and value = valueParts[1]
        const gridData = Object.entries(systemInformationData).flatMap(([key, value], entryIndex) => {
            const stringValue = typeof value === 'object' ? JSON.stringify(value) : String(value);
            const arrayValue = stringValue.split(',').map(item => item.trim()).filter(item => item.length > 0);
            
            // Create a row for each value in the array
            return arrayValue.map((singleValue, arrayIndex) => {

                const quoteColonSplit = singleValue.split('":').map(part => {
                    return part.trim()
                        .replace(/^"|"$/g, '')     // Remove leading/trailing quotes
                        .replace(/^\{"/g, '')      // Remove opening brace + quote at start
                        .replace(/"\}$/g, '');     // Remove closing quote + brace at end
                }).filter(part => part.length > 0);

                const twoDimensionalValue = quoteColonSplit.length > 1 ? quoteColonSplit : [singleValue];
                
                return {
                    id: `${entryIndex}-${arrayIndex}`,
                    item: (twoDimensionalValue[0] || '')
                        .replace(/\\n/g, '\n')           // Convert \n to actual newlines
                        .replace(/^display_/i, '')       // Remove "display_" at the beginning (case insensitive)
                        .replace(/info/i, '')            // Remove "info" anywhere (case insensitive)
                        .replace(/\bRole\b/i, 'Security Role') // Replace "Role" with "Security Role" (whole word only)
                        .replace(/\bSessionHost\b/i, 'Session Host')  // Replace "SessionHost" with "Session Host"
                        .replace(/\bQueueList\b/i, 'Queue Assignments')   // Replace "QueueList" with "Queue Assignments"
                        .replace(/\bStateSite\b/i, 'State & Selected Site')  // Replace "StateSite" with "State & Selected Site"
                        .replace(/\bVersionReleaseData\b/i, 'Application Versions & Release Dates'),   // Replace "VersionReleaseData" with "Application Versions & Release Dates"
                    value: (twoDimensionalValue[1] || '').replace(/\\n/g, '\n'), // Convert \n to actual newlines
                    //value: originalKey === 'SessionHost' ? getSessionHost() : (twoDimensionalValue[1] || '').replace(/\\n/g, '\n'),
                    valueParts: twoDimensionalValue.map(part => part.replace(/\\n/g, '\n')),
                    valueArray: arrayValue, // Original comma-split array
                    originalKey: key,
                    arrayIndex: arrayIndex,
                    totalItems: arrayValue.length
                };
            });
        });

        const networkInfo = await getLocalNetworkInfo();

        // After creating gridData, process it to replace session values
        const processedGridData = gridData.map(row => {
            if (row.originalKey === 'SessionHost' || row.item.toLowerCase().includes('session')) {
                return {
                    ...row,
                    value: ' '
                    // value: getSessionHost()
                };
            }
            return row;
        });

        //setSystemInfoResults(processedGridData);

        // After creating processedGridData), process it to replace Browservalues
        const processedGridDataWithBrowersValue = processedGridData.map(row => {
            if (row.originalKey === 'Browser' || row.item.toLowerCase().includes('browser')) {
                return {
                    ...row,
                    value: getDetailedBrowserInfo()
                    //value: getModernBrowserVersionInfo()
                };
            }
            return row;
        });

         // After processing the grid data
    const versionReleaseData = processedGridDataWithBrowersValue.find(
        row => row.originalKey === 'VersionReleaseData'
    );
    
    if (versionReleaseData) {
        // Extract just the version number if needed
        const versionMatch = versionReleaseData.value.match(/(\d+\.\d+[\.\d]*)/);
        const versionNumber = versionMatch ? versionMatch[1] : versionReleaseData.value;
        
        SessionManager.SetSession("MyYTracAppVersion", versionNumber);
    }
    

        setSystemInfoResults(processedGridDataWithBrowersValue);

    }
    catch (error) {
        await LoggerUtility.ManageErrorLogging(error, errorFormName, "handleSystemInformationBtnClick");
        // Optionally show error notification
        showAlert('error', 'Failed to load system information');
    }
    finally {
        setIsSystemInfoLoading(false);
    }
    };

    useEffect(() => {
    if (getCurrentTabType() === 'systeminfo' && systemInfoResults.length === 0) {
        handleSystemInformationBtnClick();
    }
    }, [activeTab, formFieldAccess]);

    //=======================================================================
    //  - End
    //=======================================================================

    //=======================================================================
    // Tabs Feature - Begin
    //=======================================================================

    //=======================================================================
    // Tabs Feature - End
    //=======================================================================
  

    const MyProfileFormContent = ({ activeForm }) => {
        return (
            <Box
                sx={{
                    display: activeForm ? 'block' : 'none'
                }}
            >
                <div style={{ width: "100%" }}>
                    <div className="two-column-layout-container-2" style={{ padding: "8px" }}>
                        <div className="left-column-custom-2">
                            <div className="form-dynamic-content" style={{ width: '100%' }}>
                                <form className="form-dynamic-grid">
                                    <div className='form-row'>
                                        <div className='form-group'>
                                            <div style={{ color: '#5A73EA'}}>
                                                My Profile
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </Box>
        );
    };

    const StatsFormContent = ({ activeForm }) => {
        return (
            <Box
                sx={{
                    display: activeForm ? 'block' : 'none'
                }}
            >
                <div style={{ width: "100%" }}>
                    <div className="two-column-layout-container-2" style={{ padding: "8px" }}>
                        <div className="left-column-custom-2">
                            <div className="form-dynamic-content" style={{ width: '100%' }}>
                                <form className="form-dynamic-grid">
                                    <div className='form-row'>
                                        <div className='form-group'>
                                            <div style={{ color: '#5A73EA'}}>
                                                Stats
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </Box>
        );
    };

    const AwardsFormContent = ({ activeForm }) => {
        return (
            <Box
                sx={{
                    display: activeForm ? 'block' : 'none'
                }}
            >
                <div style={{ width: "100%" }}>
                    <div className="two-column-layout-container-2" style={{ padding: "8px" }}>
                        <div className="left-column-custom-2">
                            <div className="form-dynamic-content" style={{ width: '100%' }}>
                                <form className="form-dynamic-grid">
                                    <div className='form-row'>
                                        <div className='form-group'>
                                            <div style={{ color: '#5A73EA'}}>
                                                Awards
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </Box>
        );
    };

    const SystemInfoFormContent = ({ activeForm }) => {
        return (
            <Box
                sx={{
                    display: activeForm ? 'block' : 'none'
                }}
            >
                <div style={{ width: "100%" }}>
                    <div className="two-column-layout-container-2" style={{ padding: "8px" }}>
                        <div className="left-column-custom-2">
                            <div className="form-dynamic-content" style={{ width: '100%' }}>
                                <form className="form-dynamic-grid">
                                    <div className='form-row'>
                                        <div className='form-group'>
                                            <div style={{ color: '#5A73EA'}}>
                                            CONFIGURATION
                                            </div> 
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                        <div className="right-column-custom-2">
                            <div className="form-dynamic-content" style={{ width: '100%' }}>
                                <form className="form-dynamic-grid">
                                    <div className='form-row'>
                                        <div className='form-group'>
                                            <div>
                                        
                                            </div> 
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                        <div className="right-column-custom-3">
                            {/* <Button 
                                variant="contained" 
                                onClick={handleSystemInformationBtnClick}
                                disabled={isSystemInfoLoading}
                            >
                                {isSystemInfoLoading ? 'Loading...' : 'Refresh System Info'}
                            </Button> */}
                        </div>
                    </div>

                    {/*<div className='row dotted-line-div' style={{ padding: "4px 14px" }}>
                        <div className='col-12' style={{ padding: "2px", }}>
                        </div>
                    </div>*/}
                    <div className="two-column-layout-container">
                        <div className="left-column-custom-1 text-wrapper-header-2" style={{ paddingLeft: '10px' }}></div>
                        <div className="right-column-custom-1">
                            {/*{!(formFieldAccess.workflowTypeSelect?.hide ?? false) && (
                                <div>
                                    <SearchTextFieldCustom
                                        ref={queueSearchRef}
                                        nameForField="contactSearchTxt"
                                        onIconButtonClick={handleSearchClick}
                                        onClearButtonClick={handleSearchClear}
                                        onTextChange={handleSearchChange}
                                        valueForField={searchText}
                                        labelForField="Search"
                                        iconsTooltipText={{ search: 'Search' }}
                                        iconsDisabled={{ search: true }}
                                    />
                                </div>
                            )}*/}
                        </div>
                    </div>
                    {!(formFieldAccess.myytracSearchResultsDgrd?.hide ?? false) && (
                        <div style={{ display: "flex", flexDirection: "column", marginTop: '4px', width: "100%", overflowX: "auto" }}>
                            {/* Add toolbar above DataGrid */}
                            {/* <div style={{ 
                                display: 'flex', 
                                justifyContent: 'space-between', 
                                alignItems: 'center',
                                padding: '8px 0',
                                borderBottom: '1px solid #e0e0e0',
                                marginBottom: '8px'
                            }}> */}
                                {/* <Typography variant="h6">System Information</Typography> */}
                                {/* <div style={{ display: 'flex', gap: '8px' }}> */}
                                    {/* <Button 
                                        variant="outlined" 
                                        size="small"
                                        color="ywButtonBlue"
                                        onClick={handleCopyToClipboard}
                                    >
                                        Copy
                                    </Button> */}
                                    {/* {showSupportButton && (
                                    <Button 
                                        variant="contained" 
                                        size="small"
                                        color="ywButtonBlack"
                                        onClick={handleSupportSystemInfo}
                                    >
                                        Support
                                    </Button>
                                    )} */}
                                {/* </div> */}
                            {/* </div> */}
                            
                            {systemInfoResults.length === 0 && !isSystemInfoLoading ? (
                                <div style={{ padding: '20px', textAlign: 'center' }}>
                                    No system information available. Click refresh to load data.
                                </div>
                            ) : (
                                <Box sx={{ display: 'flex', gap: 0 }}>
                                    <Box sx={{ paddingLeft: '10px', width: '50%' }}>
                                {/* <Box sx={{ flex: 1 }}> */}
                                {/* Configuration section */}
                                {/* <div style={{ color: 'blue'}}>
                                    CONFIGURATION
                                </div>
                                 */}
                                {/* DataGrid section */}
                                <div style={{ 
                                    display: "flex", 
                                    flexDirection: "column", 
                                    marginTop: '4px', 
                                    width: "98%", 
                                    overflowX: "auto",
                                    paddingLeft: '10px'
                                }}>
                                {/* DataGrid content */}    
                                <DataGridPremium
                                    rows={systemInfoResults}
                                    columns={systemInfoGridColumns}
                                    autoHeight
                                    getRowHeight={() => 'auto'} // Dynamic row height
                                    hideFooter={true}  // This will hide the entire footer including row count
            
                                    disableColumnMenu={true} // Removes column menu entirely
                                    sortingOrder={[]}
                                    sx={{
                                        '& .MuiDataGrid-cell': {
                                            whiteSpace: 'pre-wrap',
                                            wordWrap: 'break-word',
                                            lineHeight: '1.4',
                                            padding: '8px',
                                        },
                                        '& .MuiDataGrid-row': {
                                            alignItems: 'flex-start',
                                        },
                                        '& .MuiDataGrid-columnHeader .MuiDataGrid-iconButtonContainer': {
                                            display: 'none', // Hide sort icons completely
                                        },
                                        '& .MuiDataGrid-columnHeader': {
                                            '&:hover': {
                                                cursor: 'default',
                                            }
                                        }
                                    }}
                                />
                                </div>
                                </Box>
                                <Paper sx={{ width: '90px', 
                                            border: 'none',
                                            boxShadow: 'none'}}>
                                    <Stack spacing={1}>
                                    <Button
                                        variant="outlined"
                                        size="small"
                                        color="ywButtonBlue"
                                        onClick={handleCopyToClipboard}
                                    >
                                        Copy
                                    </Button>
                                    {showSupportButton && (
                                        <Button
                                        variant="contained"
                                        size="small"
                                        color="ywButtonBlack"
                                        onClick={handleSupportSystemInfo}
                                        >
                                        Support
                                        </Button>
                                    )} 
                                    </Stack>
                                </Paper>
                            </Box>
                            )}
                        </div>
                    )}
                </div>
            </Box>
        );
    };

    const mainMyYTracContent = (
        <div style={{ height: '100%', width: '100%', paddingTop: '40px', position: 'absolute', overflowY: 'auto', overflowX: 'hidden' }}>
            <div className="flex-main-frame" >
                <div className="content-main-container" style={{ width: '100%' }}>
                    <div className="pane-wrap-container">
                        <div className="pane-main-full-width-container myytrac-scroll-container">
                            <div className="form-section">
                                <Stack
                                    direction="row"
                                    alignItems="center"
                                    sx={{
                                        width: '100%'
                                    }}
                                >
                                    <div className="text-wrapper-header-bold">My Y-Trac</div>
                                    <Tabs
                                        value={activeTab}
                                        onChange={handleTabChange}
                                        aria-label="user settings tabs"
                                         sx={{
                                                '& .MuiTab-root.Mui-selected': {
                                                    color: '#5A73EA'  // This matches your blue color from the exclamation icon
                                                },
                                                '& .MuiTabs-indicator': {
                                                    backgroundColor: '#5A73EA'  // This makes the underline match too
                                                }
                                            }}
                                    >
                                        {!(formFieldAccess.btnMyYTracMyProfile?.hide ?? false) && (
                                        <Tab label="MY PROFILE" />
                                        )}
                                        {!(formFieldAccess.btnMyYTracStats?.hide ?? false) && (
                                        <Tab label="STATS" />
                                        )}
                                        {!(formFieldAccess.btnMyYTracAwards?.hide ?? false) && (
                                        <Tab label="AWARDS" />
                                        )}
                                        {!(formFieldAccess.btnMyYTracSystemInfo?.hide ?? false) && (
                                        <Tab label="SYSTEM INFO" />
                                        )}
                                    </Tabs>
                                </Stack>                                
                                <div className='row' style={{ width: '100%', padding: "0px 14px" }}>
                                    <div className='col-12' style={{ borderBottom: '1px solid grey' }}>
                                    </div>
                                </div>
                                <Box display="flex"
                                    flexDirection="column"
                                    sx={{ display: "flex",  }}
                                >
                                    {/* All forms rendered at once, visibility controlled by active tab type */}
                                    <div style={{ width: '100%', visibility: getCurrentTabType() === 'profile' ? 'visible' : 'hidden' }}>
                                        <MyProfileFormContent activeForm={getCurrentTabType() === 'profile'} />
                                    </div>
                                    
                                    <div style={{ width: '100%', visibility: getCurrentTabType() === 'stats' ? 'visible' : 'hidden' }}>
                                        <StatsFormContent activeForm={getCurrentTabType() === 'stats'} />
                                    </div>
                                    
                                    <div style={{ width: '100%', visibility: getCurrentTabType() === 'awards' ? 'visible' : 'hidden' }}>
                                        <AwardsFormContent activeForm={getCurrentTabType() === 'awards'} />
                                    </div>
                                    
                                    <div style={{ width: '100%', visibility: getCurrentTabType() === 'systeminfo' ? 'visible' : 'hidden' }}>
                                        <SystemInfoFormContent activeForm={getCurrentTabType() === 'systeminfo'} />
                                    </div>
                                </Box>
                            </div>
                        </div>
                    </div >
                </div>
            </div>
        </div>
    );

    return (
        <div>
            {mainMyYTracContent}

            {/* Include the Notification Dialog component */}
            <NotificationDialog
                openNotification={notificationDialogOpen}
                dialogContent={notificationDialogContent}
                onCloseNotification={handleCloseNotificationDialog}
                isAutoClose={timerAutoCloseNotificationDialog}
                timerDuration={timerNotificationDialogClose}
            />

            
                  <AlertNotification
                    alertType={alertProps.type}
                    message={alertProps.message}
                    open={alertProps.open}
                    onClose={handleAlertClose}
                  />

            {/* Include the loader component */}
            {/*<PageLoader isPageLoading={isPageLoading} />*/}

        </div>
    );
});

export default MyYTrac;



